import type { ComponentProps } from "react"
import { AccordionItem as AccordionItemBase } from "@/v2-ui/accordion/base/AccordionBase"
import cn from "@/v2-ui/utils/utils.cn"

export type AccordionItemProps = ComponentProps<typeof AccordionItemBase>

function AccordionItem(props: AccordionItemProps) {
  const { className, ...accordionItemBaseProps } = props
  return (
    <AccordionItemBase
      className={cn("ui-accordion-item", className)}
      {...accordionItemBaseProps}
    />
  )
}

export default AccordionItem
